export default __webpack_public_path__ + "ab9ce86823c3fa61e903f9e93dc56642.svg";